<script>
    export let src = '';
    export let alt = 'Image';
    
    if (location.hostname !== 'localhost') {
        src = '/resource/app/public' + src;
    }
</script>

<img src="{src}" alt="{alt}" {...$$restProps} />
